export default "__VITE_ASSET__R9V2rm0L__"